var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"babyDialog"},[_c('div',{staticClass:"mask"},[_c('i',{staticClass:"el-icon-close close",on:{"click":_vm.close}}),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }